<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { fetchCategoriasIva, saveCategoriaIva, removeCategoriaIva, searchCategoriasIva, subscribeToCategoriasIva, unsubscribeFromCategoriasIva } from '../controllers/categoriaIvaController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de categorías IVA
    let categoriaIvaColumns = [
        { label: 'Descripción', field: 'descripcion', type: 'text' },
        { label: 'IVA', field: 'iva', type: 'number' },
        { label: 'Sucursal', field: 'sucursal', type: 'text' },
    ];

    // Estructura del nuevo objeto Categoría IVA
    let newCategoriaIva = {
        descripcion: '',
        iva: null,
        sucursal: null,
    };

    // Configuración de los campos para la edición de Categorías IVA
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },

        { label: 'Descripción', key: 'descripcion', type: 'text', required: true },
        { label: 'IVA', key: 'iva', type: 'number', required: true }
        
    ];

    // Función para cargar datos adicionales si es necesario
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title="Categorías IVA"
    entityName="categoria_iva"
    newEntity={newCategoriaIva}
    columns={categoriaIvaColumns}
    fetchEntities={fetchCategoriasIva}
    saveEntity={saveCategoriaIva}
    removeEntity={removeCategoriaIva}
    searchEntities={searchCategoriasIva}
    subscribeToChanges={subscribeToCategoriasIva}
    unsubscribeFromChanges={unsubscribeFromCategoriasIva}
    editColumns={editColumns}
/>
